form{display:flex;flex-direction:column}form mat-form-field{flex:1}mat-option{overflow-wrap:anywhere}.training-answer{display:flex;color:#232426de}
/*# sourceMappingURL=textfield-output.component.css.map */
